module.exports = __webpack_public_path__ + "static/img/10.30b7647.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/10.png
// module id = onmQ
// module chunks = 0